module.exports = __webpack_public_path__ + "static/media/in summer cloud chased cloud.b005b014.png";